import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import {
  defaultMetaObj,
  initialDashboardLeadStatsState,
} from "store/constants";
import { getPaginatedUrlWithSearchParams } from "store/helper";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";

const { dashboardLeadStatsEndPoint } = endPoints;

export const fetchAllLeadStats = createAsyncThunk(
  "leadStats/fetchAllLeadStats",
  async (
    { page, searchParamsObj = {} }: { page: number; searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: page,
      endpoint: dashboardLeadStatsEndPoint,
      searchParams: {
        ...searchParamsObj,
      },
    });

    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const dashboardLeadSlice = createSlice({
  name: "leadStats",
  initialState: initialDashboardLeadStatsState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all dashboard task stats
    builder
      .addCase(fetchAllLeadStats.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchAllLeadStats.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.leadStats = action.payload?.objects[0] as any[];
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchAllLeadStats.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.meta = defaultMetaObj;
        }
      );
  },
});

export const dashboardLeadStatsReducer = dashboardLeadSlice.reducer;
